import { render, staticRenderFns } from "./weightAllocation.vue?vue&type=template&id=56f5b6ea&scoped=true"
import script from "./weightAllocation.vue?vue&type=script&lang=js"
export * from "./weightAllocation.vue?vue&type=script&lang=js"
import style0 from "./weightAllocation.vue?vue&type=style&index=0&id=56f5b6ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f5b6ea",
  null
  
)

export default component.exports